import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";

function DeleteNoteConfirmationDialog({ open, onClose, onConfirm, isDeleting }) {
    return (
        <Dialog open={open} dir="rtl">
            <DialogTitle>אישור מחיקה</DialogTitle>
            <DialogContent>
                האם אתה בטוח שברצונך למחוק הערה זו?
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    ביטול
                </Button>
                <Button 
                    onClick={onConfirm}  
                    color="error" 
                    variant="contained" 
                    disabled={isDeleting}
                >
                    {isDeleting ? 'מוחק...' : 'מחק'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DeleteNoteConfirmationDialog;
